import React from "react";
import { useUser } from "../../classes/contexts/UserContext";
import { formatDateWithTimeInZone } from "../../classes/utils/DateUtils";
import { useKeyboardActivation } from "../../hooks/useKeyboardActivation";

import "./PainAssessmentThumbnail.css";

const PainAssessmentThumbnail = ({ assessment, isSelected, onClick }) => {
  const { userPreferences, dateSettings } = useUser();

  // Get the highest pain level from all paths
  const getHighestPainLevel = () => {
    if (!assessment?.allPaths || assessment.allPaths.length === 0) return 0;
    return Math.max(...assessment.allPaths.map(path => path.painLevel || 0));
  };

  // Get color for pain level (same as modal)
  const getPainColor = level => {
    if (level === 0) return "var(--MDsim-font-color)";

    // Get CSS variable values from the root element
    const rootStyles = getComputedStyle(document.documentElement);
    const colors = [
      rootStyles.getPropertyValue("--MDsim-gradient-dark-green").trim(),  
      rootStyles.getPropertyValue("--MDsim-gradient-light-green").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-brillant-green").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-pale-green").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-light-yellow").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-yellow").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-orange").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-dark-orange").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-red").trim(),
      rootStyles.getPropertyValue("--MDsim-gradient-dark-red").trim(),
    ];

    return colors[level - 1] || "#ffffff";
  };

  const highestPainLevel = getHighestPainLevel();
  const painColor = getPainColor(highestPainLevel);
  const timeZone =
    userPreferences?.display_settings?.timezone?.toString() || "UTC";
  const formattedDate = formatDateWithTimeInZone(
    assessment?.createdAt || assessment?.updatedAt,
    timeZone,
    { locale: dateSettings?.locale }
  );

  return (
    <div
      className={`pain-assessment-thumbnail ${isSelected ? "selected" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={useKeyboardActivation(onClick)}
      style={{
        borderColor: painColor,
        borderWidth: isSelected ? "3px" : "2px",
        borderStyle: "solid",
      }}
    >
      <div
        className="pain-assessment-thumbnail-color"
        style={{
          backgroundColor: `${painColor}50`,
        }}
      >
        <div className="pain-assessment-thumbnail-info">
          <div className="pain-assessment-thumbnail-date">{formattedDate}</div>
          <div className="pain-assessment-thumbnail-level">
            {highestPainLevel}/10
          </div>
        </div>
      </div>

      {isSelected && <div className="pain-assessment-thumbnail-marker">&#10003;</div>}
    </div>
  );
};

export default PainAssessmentThumbnail;
